/* Emarat Gamers custom sections: scroll reveal + deal countdown */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.eg-rev:not(.eg-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('eg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTimers() {
    var timers = document.querySelectorAll('.eg-timer[data-countdown]');
    if (!timers.length) return;
    setInterval(function () {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = String(Math.floor(s / 3600)).padStart(2, '0');
      var m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      var sec = String(s % 60).padStart(2, '0');
      timers.forEach(function (t) {
        var bs = t.querySelectorAll('b');
        if (bs.length === 3) { bs[0].textContent = h; bs[1].textContent = m; bs[2].textContent = sec; }
      });
    }, 1000);
  }

  function init() { initReveal(); initTimers(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', initReveal);
})();

/* hero carousel */
(function () {
  function initHeroCarousels() {
    document.querySelectorAll('.eg-hero-car').forEach(function (car) {
      if (car.dataset.egInit) return;
      var slides = Array.prototype.slice.call(car.querySelectorAll('.eg-slide'));
      if (slides.length < 2) return;
      car.dataset.egInit = '1';
      var dots = Array.prototype.slice.call(car.querySelectorAll('.eg-dot'));
      var prev = car.querySelector('.eg-prev');
      var next = car.querySelector('.eg-next');
      var i = 0, timer = null;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('eg-cur', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('eg-on', k === i); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() {
        stop();
        if (car.dataset.autoplay !== 'true') return;
        timer = setInterval(function () { go(i + 1); }, (parseInt(car.dataset.speed, 10) || 5) * 1000);
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
      if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
      if (next) next.addEventListener('click', function () { go(i + 1); play(); });
      car.addEventListener('mouseenter', stop);
      car.addEventListener('mouseleave', play);
      document.addEventListener('shopify:block:select', function (e) {
        var idx = slides.indexOf(e.target);
        if (idx > -1) { stop(); go(idx); }
      });
      play();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeroCarousels);
  else initHeroCarousels();
  document.addEventListener('shopify:section:load', initHeroCarousels);
})();

/* redirect old contact links to the new contact page */
(function () {
  function rewriteContactLinks() {
    document.querySelectorAll('a[href$="/policies/contact-information"]').forEach(function (a) {
      a.href = '/pages/contact';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewriteContactLinks);
  else rewriteContactLinks();
})();

/* dark / light theme toggle */
(function () {
  function initThemeToggle() {
    document.querySelectorAll('.eg-theme-toggle').forEach(function (btn) {
      if (btn.dataset.egInit) return;
      btn.dataset.egInit = '1';
      btn.addEventListener('click', function () {
        var dark = document.documentElement.classList.toggle('eg-dark');
        try { localStorage.setItem('eg-theme', dark ? 'dark' : 'light'); } catch (e) {}
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initThemeToggle);
  else initThemeToggle();
  document.addEventListener('shopify:section:load', initThemeToggle);
})();

/* hero Instagram feed — continuous auto-scroll (pauses on hover) */
(function () {
  function initIgAutoscroll() {
    document.querySelectorAll('.eg-ig-col[data-autoscroll]').forEach(function (col) {
      if (col.dataset.egInit) return;
      var scroller = col.querySelector('.eg-ig-scroll');
      if (!scroller) return;
      col.dataset.egInit = '1';
      var paused = false, raf = null, waited = 0;
      col.addEventListener('mouseenter', function () { paused = true; });
      col.addEventListener('mouseleave', function () { paused = false; });
      function step() {
        // wait until the Instafeed app has injected enough content to scroll
        if (scroller.scrollHeight <= scroller.clientHeight + 8) {
          waited += 1;
          if (waited < 600) { raf = requestAnimationFrame(step); }
          else { raf = requestAnimationFrame(step); } // keep waiting; feed may load late
          return;
        }
        if (!paused) {
          scroller.scrollTop += 0.5;
          if (scroller.scrollTop >= scroller.scrollHeight - scroller.clientHeight - 1) {
            scroller.scrollTop = 0; // loop back to top
          }
        }
        raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initIgAutoscroll);
  else initIgAutoscroll();
  document.addEventListener('shopify:section:load', initIgAutoscroll);
})();
